import { Culture, cultureLabels, cultures } from "../../context/VolunteersHighlightContext/constants";

export const GENERAL_SECTION_KEY = "general";

export const getTextSectionKey = (culture: Culture) => `text-${culture}`;

export const KvkkFormKeys = [GENERAL_SECTION_KEY, ...cultures.map(getTextSectionKey)];

export const KvkkSectionLabels = {
	GENERAL: "Genel Bilgiler",
	getText: (culture: Culture) => `KVKK Metni - ${cultureLabels[culture]}`,
};

export const KvkkGeneralTexts = {
	platform: {
		label: "Platform",
		placeholder: "Platform seçiniz",
	},
	appId: {
		label: "Uygulama",
		placeholder: "Uygulama seçiniz",
	},
	isPage: {
		label: "Sayfa Metni",
		helperText: "Açık olan metin KVKK sayfasında, web'de proje başvurusunda da gösterilir; kapalı olan KVKK onay penceresinde.",
	},
	isManager: {
		label: "Yönetici Metni",
	},
};

type TextFieldTexts = {
	title: { label: string; placeholder: string };
	text: { label: string; placeholder: string };
};

export const KvkkTextTexts: Record<Culture, TextFieldTexts> = {
	"tr-TR": {
		title: {
			label: "Başlık",
			placeholder: "KVKK Aydınlatma Metni",
		},
		text: {
			label: "Metin",
			placeholder: "Kişisel verileriniz, aydınlatma metninde açıklanan amaçlarla işlenir.",
		},
	},
	"en-US": {
		title: {
			label: "Title",
			placeholder: "Clarification Text",
		},
		text: {
			label: "Text",
			placeholder: "Your personal data is processed for the purposes explained in the clarification text.",
		},
	},
};
